import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=2bed7a03&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"
import style0 from "./download.css?vue&type=style&index=0&id=2bed7a03&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed7a03",
  null
  
)

export default component.exports